<template>
    <div class="Content">
        <h3 v-html="texts[id].title"></h3>
        <hr>
        <b-row>
            <b-col cols="4">
                <b-row class="sokhanran">
                    <b-col cols="3" style="padding:0;">
                        <img class="" style="margin:0 auto;" :src="'image/zan/'+texts[id].image"
                             alt="بنیاد ایران شناسی"/>
                    </b-col>
                    <b-col cols="9" style="padding-top: 10px;">
                        <p style="color:#148543;font-size:11px;"><b-icon icon="person-check-fill" animation="fade" font-scale="1"></b-icon>  سخنرانی : <span
                                style="color:#148543;font-size:12px;"><strong>{{texts[id].name}}</strong></span>
                        </p>
                        <p style="font-size:10px;color:#666;margin-top: 10px;line-height: 30px"><b-icon icon="sun" ></b-icon>  {{texts[id].post}}</p>
                    </b-col>
                </b-row>
                <app-list-lecturers></app-list-lecturers>
            </b-col>
            <b-col cols="8" class="border-right" style="border-radius: 10px;">
                <p
                        style="text-align:justify;background-color:#efefef;padding:10px;margin-top:1px;border-radius:5px;line-height: 1.9rem;"
                        class="persiaNumber"
                        dir="rtl"
                        v-if="show">
                    به گزارش روابط عمومی بنیاد ایرانشناسی، حضرت آیت ‌ا... سیدمحمد خامنه‌ای، رئیس محترم بنیاد ایرا‌نشناسی
                    و رئیس همایش بین‌المللی «جایگاه زن در تمدن ایران و اسلام»، در افتتاحیه همایش گفت: هدف اصلی از
                    برگزاری همایش؛ آغاز گفتگوی جهانی با متفکران عالم اعم از مرد و زن و تدوین قوانینی جهت بیان مسئولیت و
                    شأن واقعی زن بر مبنای تاریخ ایران و اسلام است. مشروح بیانات رئیس بنیاد ایرانشناسی به شرح زیر است:
                </p>
                <h3 style="margin:10px;" v-if="show">
                    بِسْمِ اللَّهِ الرَّحْمنِ الرَّحيمِ
                </h3>
                <p
                        style="text-align:justify;line-height: 1.9rem;"
                        class="persiaNumber"
                        dir="rtl"
                        v-html="texts[id].body.replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d])"
                >
                </p>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import ListLecturers from "./ListLectures";
    import {texts} from "../../data/main";
    export default {
        data() {
            return {
                texts,
                // id:0,
            }
        },
        components: {
            appListLecturers: ListLecturers,
        },
        computed: {
            show() {
                if (this.$route.query.q === "0" || !this.$route.query.q ) {
                    return true;
                } else {
                    return false
                }
            },
            id() {
                if (this.$route.query.q ) {
                    return this.$route.query.q;
                } else {
                    return 0;
                }
            },
        },
        watch: {
            // '$route'(to) {
            //     return this.id = to.query.q;
            // }
        },

        props: {}
        ,
    };
</script>
<style slot-scope="style">
    h3 {
        line-height: 2.2rem;
        font-size: 1.4rem;
        margin-top: 60px;
    }

    .sokhanran {
        margin-bottom: 30px;
        background-color: #efefef;
        border-radius: 7px;
        padding: 5px;
        margin-left: 10px;
    }
</style>